<template>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="plansVisible">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{$t('Court plans')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat v-on:click="closePlans">{{$t('Close')}}</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <img src="../../assets/valjakuteplaanid.jpg" alt="" />
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ["plansVisible"],
        methods: {
            closePlans: function () {
                this.$parent.closePlans();
            }
        }
    }
</script>

<style scoped>
    img {max-width: 100%;}
</style>


// WEBPACK FOOTER //
// src/views/calendar/Plans.vue